import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submitWrapper: {
    marginBottom: theme.spacing(1),
    position: "relative"
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  email: {
    textAlign: "center"
  },
  resend: {
    cursor: "pointer"
  },
  error: {
    textAlign: "center",
    color: "red"
  }
}));
